import i18next from 'i18next';

i18next.addResources('es', 'ChangeWorkspace', {
  title: '¿DESEA CAMBIAR DE ESPACIO DE TRABAJO?',
  subtitle: 'Transferiremos su/s credencial/es al espacio de trabajo:',
  currentWorkspace: 'Su espacio de trabajo actual es:',
  body: 'De realizar el cambio, perderá acceso a todos los expedientes, tareas y pruebas de su espacio de trabajo actual, pero mantendrá el acceso a los expedientes de su credencial personal.',
  changeWorkspace: 'Cambiar de espacio'
});
